<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->

<ng-template #tableHead>
  <div class="flex items-center justify-end gap-3 w-full">
    <div class="flex items-center gap-2">
      <span class="text-sm font-medium text-slate-600">Sort by:</span>
      <nz-select
        style="width: 220px"
        [(ngModel)]="sortKey"
        (ngModelChange)="applyFilters()"
        nzPlaceHolder="Sort By"
      >
        <nz-option
          *ngFor="let option of sortOptions"
          [nzLabel]="option.label"
          [nzValue]="option.value"
        ></nz-option>
      </nz-select>
    </div>

    <nz-switch
      [(ngModel)]="showTesting"
      (ngModelChange)="testFilterFn()"
      nzCheckedChildren="Hide Test Users"
      nzUnCheckedChildren="Show Test Users"
    >
    </nz-switch>

    <button
      class="btn-color"
      nz-button
      nzSize="small"
      nzType="primary"
      (click)="clearFilter()"
    >
      Clear Filter
    </button>
  </div>
</ng-template>

<div class="p-6 space-y-4">
  <div>
    <h1 class="text-2xl font-bold text-slate-900">Snapshot Disease Scores</h1>
    <p class="text-sm text-slate-500">
      Snapshot ID: <span class="font-mono">{{ snapshotId }}</span>
    </p>
  </div>

  <div class="bg-white rounded-xl border p-4">
    <div class="flex justify-end w-full">
      <nz-input-group
        nzSearch
        nzSize="large"
        [nzAddOnAfter]="suffixButton"
        style="width: 320px"
      >
        <input
          type="text"
          nz-input
          [(ngModel)]="searchDiseaseName"
          placeholder="Search disease name"
          (keyup.enter)="applyFilters()"
        />
      </nz-input-group>
    </div>

    <ng-template #suffixButton>
      <button
        nz-button
        nzType="primary"
        nzSize="small"
        nzSearch
        (click)="applyFilters()"
      >
        Search
      </button>
    </ng-template>
  </div>

  <nz-table
    [nzData]="rows"
    [nzLoading]="loading"
    [nzFrontPagination]="false"
    [nzTotal]="total"
    [nzPageIndex]="page"
    [nzPageSize]="pageSize"
    [nzTitle]="tableHead"
    [nzScroll]="{ x: '1300px' }"
    (nzPageIndexChange)="onPageIndexChange($event)"
    (nzPageSizeChange)="onPageSizeChange($event)"
  >
    <thead>
      <tr>
        <th>Disease</th>
        <th>
          Disease ID
          <nz-filter-trigger
            [nzActive]="selectedDiseaseIds.length > 0"
            [nzDropdownMenu]="diseaseIdMenu"
          >
            <span nz-icon nzTheme="outline" nzType="filter"></span>
          </nz-filter-trigger>
        </th>
        <th>DRS</th>
        <th>PDH</th>
        <th>
          Band
          <nz-filter-trigger
            [nzActive]="selectedBands.length > 0"
            [nzDropdownMenu]="bandMenu"
          >
            <span nz-icon nzTheme="outline" nzType="filter"></span>
          </nz-filter-trigger>
        </th>
        <th>Questionnaire</th>
        <th>Lab</th>
        <th>
          Status
          <nz-filter-trigger
            [nzActive]="selectedStatuses.length > 0"
            [nzDropdownMenu]="statusMenu"
          >
            <span nz-icon nzTheme="outline" nzType="filter"></span>
          </nz-filter-trigger>
        </th>
        <th>
          Insights Status
          <nz-filter-trigger
            [nzActive]="selectedInsightStatuses.length > 0"
            [nzDropdownMenu]="insightStatusMenu"
          >
            <span nz-icon nzTheme="outline" nzType="filter"></span>
          </nz-filter-trigger>
        </th>
        <th>Created At</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows">
        <td>{{ row.diseaseName }}</td>
        <td class="font-mono text-xs">{{ row.diseaseId }}</td>
        <td>{{ row.drsScore ?? "—" }}</td>
        <td>{{ row.pdhScore ?? "—" }}</td>
        <td>{{ row.band || "—" }}</td>
        <td>{{ row.questionnaireScore ?? "—" }}</td>
        <td>{{ row.labMarkersScore ?? "—" }}</td>
        <td>{{ row.status || "—" }}</td>
        <td>{{ row.insightsGeneratingStatus || "—" }}</td>
        <td>{{ row.createdAt ? (row.createdAt | date: "medium") : "—" }}</td>
        <td>
          <button nz-button nzType="link" (click)="openDetail(row)">
            Trace Detail
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>

<!-- Disease ID Filter -->
<nz-dropdown-menu #diseaseIdMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <span class="font-bold">Disease ID</span>
    <nz-divider></nz-divider>

    <nz-checkbox-wrapper (nzOnChange)="diseaseIdFilterChangeFn($event)">
      <div *ngFor="let topic of diseaseIdCheckBoxOptions">
        <label nz-checkbox [nzValue]="topic.value" [ngModel]="topic.checked">
          {{ topic.label }}
        </label>
      </div>
    </nz-checkbox-wrapper>

    <div nz-row nzJustify="end">
      <button
        class="m-1 btn-color"
        nz-button
        nzType="primary"
        (click)="diseaseIdFilterFn()"
      >
        Ok
      </button>

      <button
        class="m-1 btn-color"
        nz-button
        nzType="primary"
        (click)="clearFilter()"
      >
        Reset
      </button>
    </div>
  </div>
</nz-dropdown-menu>

<!-- Band Filter -->
<nz-dropdown-menu #bandMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <span class="font-bold">Band</span>
    <nz-divider></nz-divider>

    <nz-checkbox-wrapper (nzOnChange)="bandFilterChangeFn($event)">
      <div *ngFor="let topic of bandCheckBoxOptions">
        <label nz-checkbox [nzValue]="topic.value" [ngModel]="topic.checked">
          {{ topic.label }}
        </label>
      </div>
    </nz-checkbox-wrapper>

    <div nz-row nzJustify="end">
      <button
        class="m-1 btn-color"
        nz-button
        nzType="primary"
        (click)="bandFilterFn()"
      >
        Ok
      </button>

      <button
        class="m-1 btn-color"
        nz-button
        nzType="primary"
        (click)="clearFilter()"
      >
        Reset
      </button>
    </div>
  </div>
</nz-dropdown-menu>

<!-- Status Filter -->
<nz-dropdown-menu #statusMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <span class="font-bold">Status</span>
    <nz-divider></nz-divider>

    <nz-checkbox-wrapper (nzOnChange)="statusFilterChangeFn($event)">
      <div *ngFor="let topic of statusCheckBoxOptions">
        <label nz-checkbox [nzValue]="topic.value" [ngModel]="topic.checked">
          {{ topic.label }}
        </label>
      </div>
    </nz-checkbox-wrapper>

    <div nz-row nzJustify="end">
      <button
        class="m-1 btn-color"
        nz-button
        nzType="primary"
        (click)="statusFilterFn()"
      >
        Ok
      </button>

      <button
        class="m-1 btn-color"
        nz-button
        nzType="primary"
        (click)="clearFilter()"
      >
        Reset
      </button>
    </div>
  </div>
</nz-dropdown-menu>

<!-- Insight Status Filter -->
<nz-dropdown-menu #insightStatusMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <span class="font-bold">Insights Status</span>
    <nz-divider></nz-divider>

    <nz-checkbox-wrapper (nzOnChange)="insightStatusFilterChangeFn($event)">
      <div *ngFor="let topic of insightStatusCheckBoxOptions">
        <label nz-checkbox [nzValue]="topic.value" [ngModel]="topic.checked">
          {{ topic.label }}
        </label>
      </div>
    </nz-checkbox-wrapper>

    <div nz-row nzJustify="end">
      <button
        class="m-1 btn-color"
        nz-button
        nzType="primary"
        (click)="insightStatusFilterFn()"
      >
        Ok
      </button>

      <button
        class="m-1 btn-color"
        nz-button
        nzType="primary"
        (click)="clearFilter()"
      >
        Reset
      </button>
    </div>
  </div>
</nz-dropdown-menu>
